import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-23a96368"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "page-wrapper"
};
const _hoisted_2 = {
  class: "content-wrapper"
};

const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "lecture-title"
}, null, -1));

const _hoisted_4 = {
  class: "lecture-main"
};
const _hoisted_5 = {
  key: 0
};
const _hoisted_6 = {
  key: 2,
  class: "end-lecture"
};

const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "回顾", -1));

const _hoisted_8 = [_hoisted_7];
const _hoisted_9 = {
  key: 3,
  class: "lecture-end-list"
};
import Head from 'components/Head';
import LectureCard from './components/lectureCardNew';
import LectureEndCard from './components/lectureEndCardNew';
import { getUrlParams } from '@/plugins/utils';
import { Empty } from 'zhs-components';
export default {
  setup(__props) {
    const $http = inject('$http');
    const menuId = getUrlParams('menuId');
    const menuInfo = ref({});
    const userInfo = ref();
    provide('userInfo', userInfo);

    const getUserInfo = info => {
      userInfo.value = info;
    };

    const handleIntro = () => {
      window.location.href = `/forumIntro.html?menuId=${menuInfo.value.menu_id}&name=${menuInfo.value.nav_name}`;
    }; // 获取进行未进行培训列表


    const lectureList = ref([]);

    const getLectureList = async () => {
      const res = await $http.getLectureList({
        menu_id: menuId,
        start_time_sort: 1,
        live_status: 1
      });
      console.log('进行未进行培训列表', res);
      lectureList.value = res.content || [];
    };

    getLectureList(); // 获取已结束培训列表

    const finishLectureList = ref([]);
    const pageInfo = reactive({
      pageNum: 1,
      pageSize: 8,
      total: 0
    });

    const getFinishLecture = async () => {
      const res = await $http.getLectureList({
        menu_id: menuId,
        start_time_sort: 2,
        '_pageable.page': pageInfo.pageNum - 1,
        '_pageable.size': pageInfo.pageSize,
        live_status: 2
      });
      console.log('已结束培训列表', res);
      finishLectureList.value = res.content || [];
      pageInfo.total = +res.totalElements || 0;
    };

    getFinishLecture(); // 分页改变时

    const pageIndexChange = index => {
      pageInfo.pageNum = index;
      getFinishLecture();
    };

    return (_ctx, _cache) => {
      const _component_el_pagination = _resolveComponent("el-pagination");

      return _openBlock(), _createElementBlock("section", _hoisted_1, [_createVNode(_unref(Head), {
        menuInfo: menuInfo.value,
        "onUpdate:menuInfo": _cache[0] || (_cache[0] = $event => menuInfo.value = $event),
        onGetUserInfo: getUserInfo
      }, null, 8, ["menuInfo"]), _createElementVNode("div", {
        class: "center_img",
        onClick: handleIntro
      }), _createElementVNode("section", _hoisted_2, [_hoisted_3, _createElementVNode("div", _hoisted_4, [lectureList.value.length ? (_openBlock(), _createElementBlock("div", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(lectureList.value, (item, index) => {
        return _openBlock(), _createBlock(_unref(LectureCard), {
          key: item.id,
          lectureData: item,
          index: index,
          onUpdateStatus: getLectureList
        }, null, 8, ["lectureData", "index"]);
      }), 128))])) : (_openBlock(), _createBlock(_unref(Empty), {
        key: 1,
        text: "暂无数据"
      })), finishLectureList.value.length ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_8)) : _createCommentVNode("", true), finishLectureList.value.length ? (_openBlock(), _createElementBlock("div", _hoisted_9, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(finishLectureList.value, (item, index) => {
        return _openBlock(), _createBlock(_unref(LectureEndCard), {
          index: index,
          key: item.id,
          finishLecture: item
        }, null, 8, ["index", "finishLecture"]);
      }), 128))])) : _createCommentVNode("", true), _createVNode(_component_el_pagination, {
        class: "lecture-pagination",
        background: "",
        layout: "prev, pager, next",
        onCurrentChange: pageIndexChange,
        "current-page": _unref(pageInfo).pageNum,
        total: _unref(pageInfo).total,
        "page-size": _unref(pageInfo).pageSize,
        "hide-on-single-page": ""
      }, null, 8, ["current-page", "total", "page-size"])])])]);
    };
  }

};